import { Icon } from "@material-ui/core"
import loff from './logos/ouoff.png'
                                       
export const Iconou1 = () => (
    <Icon>
        <img src={loff} />
    </Icon>
)